<template>
  <div>
    <h3>{{ $t('referral') }}</h3>
    <b-card>
      <validation-observer
        ref="securityTab"
      >
        <p>{{ $t('referral-desc') }}</p>
        <br>
        <b-form>
          <b-row>
            <b-col
              sm="12"
              xl="6"
              class="col-xxl-4"
            >
              <b-form-group
                :label="$t('referral_id')"
                label-for="referral_id"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('referral_id')"
                  vid="referral_id"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="referral_id"
                      v-model="formData.referralId"
                      name="old-password"
                      :placeholder="$t('referral_id')"
                    />
                    <template #append>
                      <b-button
                        type="button"
                        variant="primary"
                        style="height: 38px;gap: 3px;"
                        class="d-flex justify-center align-items-center mb-0 "
                        @click="copyRefCode()"
                      >
                        <BIconFileEarmarkFill class="mb-0" />
                        <span>{{ $t('copy') }}</span>
                      </b-button>
                    </template>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </b-col>
            <b-col
              cols="12"
              class="d-flex justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mr-1"
                pill
                @click="storeReferralId"
              >
                <span v-if="!storeReferralPending"> {{ $t('code_registration') }}</span>
                <b-spinner
                  v-else
                  small
                  type="grow"
                />
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
    <b-card
      class=""
    >
      <b-row align-h="center">
        <b-col cols="12">
          <b-table
            responsive
            striped
            hover
            sticky-header="1000px"
            :items="items"
            :fields="computedFields"
          >
            <template #cell(created_at)="data">
              <span>
                {{ moment(data.item.date).format('YYYY-MM-DD') }}
              </span>
            </template>
          </b-table>
        </b-col>
        <b-col cols="auto">
          <b-pagination
            v-if="paginate.total > paginate.per_page"
            v-model="paginate.page"
            :total-rows="paginate.total"
            :per-page="paginate.per_page"
            align="fill"
            size="sm"
            class="mb-1"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BIconFileEarmarkFill,
} from 'bootstrap-vue'
import referral from '@/views/logics/profile/referral'

export default {
  components: {
    BIconFileEarmarkFill,
  },
  mixins: [referral],
}
</script>
